import classNames from "classnames";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { getScaleImageSrc } from "./../../wix-rich-content-common/lib/imageUtils";
import styles from "../statics/styles/widget-scss";
import { CardContent } from "./CardContent";
const getImageTargetHeight = (width, height, targetWidth) => {
  const proportion = height / width;
  const targetHeight = proportion * targetWidth;
  return targetHeight;
};
const Card = (props) => {
  const { tabIndex } = useContext(RicosContext);
  const getImageSrc = ({ targetWidth }) => {
    if (props.image && props.image.width && props.image.height && props.image.src?.url) {
      const targetHeight = getImageTargetHeight(props.image.width, props.image.height, targetWidth);
      return getScaleImageSrc(props.image.src.url, targetWidth, targetHeight);
    }
    return props.image?.src?.url;
  };
  const [imageSrc, setImageSrc] = useState(
    () => (
      // value for ssr and first render
      getImageSrc({ targetWidth: 185 })
    )
  );
  const setRef = (ref) => {
    if (ref && props.image?.width && props.image?.height) {
      const targetWidth = ref.getBoundingClientRect()?.width;
      setImageSrc(getImageSrc({ targetWidth }));
    }
  };
  const imageStyle = imageSrc ? { backgroundImage: `url(${imageSrc})` } : {};
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    /* @__PURE__ */ React.createElement(
      "a",
      {
        className: styles.link,
        href: props.disabled ? void 0 : props.url,
        target: "_blank",
        ref: setRef,
        tabIndex
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { direction: props.direction },
          className: classNames(styles[props.direction], styles.container, styles.cardLayout)
        },
        imageSrc && /* @__PURE__ */ React.createElement("div", { style: imageStyle, className: styles.image }),
        /* @__PURE__ */ React.createElement(
          CardContent,
          {
            info: props.subtitleInfo,
            title: props.title,
            buttonText: props.buttonText,
            disabled: props.disabled,
            t: props.t
          }
        )
      )
    )
  );
};
var Card_default = Card;
export {
  Card_default as default
};
//# sourceMappingURL=Card.js.map
